import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { HelpGlossary } from '@model';

@Component({
    selector: 'app-help-glossary',
    templateUrl: './help-glossary.component.html',
    standalone: false
})
export class HelpGlossaryComponent implements OnInit, OnChanges {
  @Input()
  glossaryData: HelpGlossary[];
  glossarySorted: HelpGlossary[];
  glossaryDisplay: HelpGlossary[];

  constructor() {}

  ngOnInit() {
    this.initGlossary();
  }

  ngOnChanges() {
    this.initGlossary();
  }

  initGlossary() {
    if (!this.glossaryData) {
      return;
    }

    this.glossarySorted = [...this.glossaryData];
    this.sortGlossary();
    this.glossaryDisplay = [...this.glossarySorted];
  }

  sortGlossary() {
    this.glossarySorted.sort((a, b) => {
      return this.compare(a.term.toUpperCase(), b.term.toUpperCase(), true);
    });
  }

  compare(a, b, isAsc) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  doSearch(searchPhrase: string) {
    if (searchPhrase.trim().length === 0) {
      this.glossaryDisplay = [...this.glossarySorted];
      return;
    }

    const searchPhraseLower = searchPhrase.toLowerCase();
    this.glossaryDisplay = this.glossarySorted.filter(g => g.term.toLowerCase().indexOf(searchPhraseLower) !== -1);
  }
}
